<ul class="list list--inline">

    {#each names as name (name.name)}

    <li>

        <Badge variant="secondary">{name}</Badge>

    </li>

    {/each}
</ul>

<script>
    import Badge from 'components/Badge.html'

    export default {
        components: {
            Badge
        },
        computed: {
            names: ({ shorthands }) => {                
                const softwareShorthands = {
                    maya: 'Autodesk Maya',
                    zbrush: 'Pixologic zBrush',
                    houdini: 'SideFX Houdini',
                    mari: 'The Foundry Mari',
                    nuke: 'The Foundry Nuke',
                    photoscan: 'Agisoft PhotoScan',
                    cinema4d: 'Maxon Cinema 4D',
                    photoshop: 'Adobe Photoshop',
                    aftereffects: 'Adobe AfterEffects'
                }
                let names = []

                for (let shorthand of shorthands.map(name => name.trim())) {
                    if (softwareShorthands[shorthand]) {
                        names.push(softwareShorthands[shorthand])
                    }
                }

                return names.sort()
            }
        },
        data() {
            return {
                shorthands: []
            }
        }
    }
</script>